import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Phone, Mail, Instagram, Globe, HelpCircle } from "lucide-react";

export default function Help() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/content/help").then(r => setC(r.data)); }, []);
  const e = c?.extra || {};
  return (
    <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="flex items-center gap-2 mb-3"><HelpCircle className="text-[#004BCA]"/><span className="text-xs font-bold tracking-widest text-slate-500">SUPPORT</span></div>
      <h1 className="font-display text-4xl md:text-5xl font-bold mb-6">{c?.title || "Help & Support"}</h1>
      <p className="text-slate-700 leading-relaxed">{c?.body}</p>
      <div className="grid sm:grid-cols-2 gap-3 mt-8">
        <Card icon={Phone} label="Contact" value={e.phone}/>
        <Card icon={Mail} label="Email" value={e.email}/>
        <Card icon={Instagram} label="Instagram" value={e.instagram}/>
        <Card icon={Globe} label="Website" value={e.website}/>
      </div>
    </main>
  );
}
function Card({ icon: Icon, label, value }) {
  return <div className="bg-white border border-slate-100 rounded-2xl p-4 flex items-center gap-3"><span className="grid place-items-center w-10 h-10 rounded-xl bg-[#004BCA]/10 text-[#004BCA]"><Icon size={18}/></span><div><div className="text-xs text-slate-500">{label}</div><div className="font-semibold">{value}</div></div></div>;
}
